import { AddressConfirmationDecision } from '../interfaces';
import { isValidAddressQuery } from '../utils/client-address.util';

/**
 * Determines whether address geocoding should be triggered.
 */
export function shouldGeocodeAddress(
	newAddress?: string | null,
	currentAddress?: string | null
): boolean {
	if (!isValidAddressQuery(newAddress)) {
		return false;
	}
	return newAddress !== currentAddress;
}

/**
 * Evaluates business condition to decide if the modal can close and if the form can be reset.
 */
export function evaluateAddressConfirmation(params: {
	isLoggedIn: boolean;
	showNameAddressInput: boolean;
	isAddressAvailable: boolean;
}): AddressConfirmationDecision {
	const isUnsavedNamedAddressOutOfRange =
		params.isLoggedIn && params.showNameAddressInput && !params.isAddressAvailable;

	return {
		shouldDismissModal: params.isAddressAvailable,
		shouldResetForm: !isUnsavedNamedAddressOutOfRange,
	};
}
